import { DynamicModule } from '1-project/DynamicModule/DynamicModule';
import { GoToTopNavigation } from '2-feature/Navgation/GoToTopNavigation';
import { MainRegion } from '1-project/MainRegion/MainRegion';
import { Speaker } from '2-feature/Speaker/Speaker';

interface Props extends Content.Page {
	properties: Content.BasePage;
}

export const HomePage = (props: Props) => {
	const { properties } = props;
	const { pageHeader, pageSections } = properties ?? {};
	return (
		<MainRegion
			header={pageHeader.map((headerModule, index) => (
				<DynamicModule key={index} module={headerModule} />
			))}
			breadCrumb={null}
			speaker={<Speaker background="Primary" />}
		>
			{pageSections.map((sectionModule, index) => (
				<DynamicModule key={index} module={sectionModule} />
			))}
			<GoToTopNavigation />
		</MainRegion>
	);
};
